var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          ref: "browse",
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "context-menu-items": _vm.contextMenuItems,
            "button-bar-items": _vm.buttonBarItems,
            "controls-disabled": false,
            "edit-buttons-hidden": "",
            "search-enabled": true,
            "show-reports": _vm.showReports,
            multiple: "",
          },
          on: {
            state: function ($event) {
              _vm.browseState = $event
            },
            markAsDelivered: function ($event) {
              return _vm.onMarkAsDelivered($event)
            },
            markAsUndeliverable: function ($event) {
              return _vm.markAsUndeliverable($event)
            },
            markAsDeliverable: function ($event) {
              return _vm.markAsDeliverable($event)
            },
            "col-click-result": _vm.onColClick,
          },
        },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.document-info"),
                  expression: "$ct('tooltip.document-info')",
                },
              ],
              attrs: {
                slot: "extra-buttons",
                disabled:
                  _vm.selectedItems.length == 0 || _vm.selectedItems.length > 1,
              },
              on: {
                click: function ($event) {
                  return _vm.info()
                },
              },
              slot: "extra-buttons",
            },
            [_c("w-fa", { attrs: { icon: "eye" } })],
            1
          ),
          _vm._t(
            "browse-action-buttons",
            function () {
              return [
                _vm.bookYearSelect
                  ? _c(
                      "div",
                      { staticClass: "bookyear-wrapper" },
                      [
                        _c("app-select-book-year", {
                          attrs: {
                            value: _vm.selectedBookYear,
                            "include-book-year0": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onBookYearChange($event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            { slot: "browse-action-buttons" }
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editDeliveryDate,
            callback: function ($$v) {
              _vm.editDeliveryDate = $$v
            },
            expression: "editDeliveryDate",
          },
        },
        [
          _c("app-mark-as-delivered-date", {
            attrs: { "selected-items": _vm.selectedItems },
            on: {
              close: function ($event) {
                _vm.editDeliveryDate = false
              },
              finished: function ($event) {
                return _vm.onMarkedAsDelivered()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.markAsDeliveredRow !== null } },
        [
          _vm.markAsDeliveredRow
            ? _c("app-mark-as-delivered", {
                attrs: { row: _vm.markAsDeliveredRow },
                on: {
                  close: function ($event) {
                    _vm.markAsDeliveredRow = null
                  },
                  finished: function ($event) {
                    return _vm.onMarkedAsDelivered()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.quickEditSellPriceModal
        ? _c("app-product-quick-edit-sell-price", {
            attrs: {
              product: _vm.quickEditSellPriceModal.product,
              category: _vm.quickEditSellPriceModal.category,
            },
            on: {
              close: function ($event) {
                _vm.quickEditSellPriceModal = null
              },
              refresh: function ($event) {
                return _vm.refreshRow(_vm.quickEditSellPriceModal.row)
              },
            },
          })
        : _vm._e(),
      _vm.quickEditSellPriceIncVatModal
        ? _c("app-product-quick-edit-sell-price-inc-vat", {
            attrs: {
              product: _vm.quickEditSellPriceIncVatModal.product,
              category: _vm.quickEditSellPriceIncVatModal.category,
            },
            on: {
              close: function ($event) {
                _vm.quickEditSellPriceIncVatModal = null
              },
              refresh: function ($event) {
                return _vm.refreshRow(_vm.quickEditSellPriceIncVatModal.row)
              },
            },
          })
        : _vm._e(),
      _vm.toQuickEditMainSupplierCatalogPriceProduct && _vm.toQuickEditPriceRow
        ? _c("app-product-quick-edit-main-supplier-buy-catalog-price", {
            attrs: { product: _vm.toQuickEditMainSupplierCatalogPriceProduct },
            on: {
              close: function ($event) {
                _vm.toQuickEditMainSupplierCatalogPriceProduct = null
              },
              refresh: function ($event) {
                return _vm.refreshRow(_vm.toQuickEditPriceRow)
              },
            },
          })
        : _vm._e(),
      _vm.toQuickEditMainSupplierNettoPriceProduct && _vm.toQuickEditPriceRow
        ? _c("app-product-quick-edit-main-supplier-buy-netto-price", {
            attrs: { product: _vm.toQuickEditMainSupplierNettoPriceProduct },
            on: {
              close: function ($event) {
                _vm.toQuickEditMainSupplierNettoPriceProduct = null
              },
              refresh: function ($event) {
                return _vm.refreshRow(_vm.toQuickEditPriceRow)
              },
            },
          })
        : _vm._e(),
      _vm.createAutomaticAfleveringsbonnenOfDeliveredGoodsModalOpen
        ? _c(
            "app-create-automatic-afleveringsbonnen-of-delivered-goods-modal",
            {
              attrs: {
                rows: _vm.selectedItems,
                "contact-group-id": _vm.contactGroupId,
              },
              on: {
                close: function ($event) {
                  _vm.createAutomaticAfleveringsbonnenOfDeliveredGoodsModalOpen = false
                },
              },
            }
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }